<template>
  <!-- Header导航栏部分 -->
  <header class="header">
    <ManagementHeaderBar :index="'/stastics'" />
  </header>
  <el-select v-model="value" class="m-2" size="large" :placeholder="$t('allTime')"
    style="width: 240px; --el-color-primary: #f36633; padding-left: 2rem; margin-top: 6rem;" @change="selectChange">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
  </el-select>

  <div class="charts-container">
    <div class="chart-wrapper">
      <div class="chart-title">
        {{ $t("idea") }}
      </div>
      <div ref="chartDom" class="chartDom"></div>
    </div>
    <div class="chart-wrapper">
      <div class="chart-title">
        {{ $t("Comment") }}
      </div>
      <div ref="chartDom2" class="chartDom"></div>
    </div>
    <div class="chart-wrapper">
      <div class="chart-title">
        {{ $t("User") }}
      </div>
      <div ref="chartDom3" class="chartDom"></div>
    </div>
  </div>
</template>

<style scoped>
.chartDom {
  width: 100%;
  height: 400px;
  /* Set a fixed height for all charts */
}

.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  backdrop-filter: blur(5px);
  z-index: 9;
}

.charts-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-top: 2rem;
}

.chart-wrapper {
  flex: 1;
  padding: 1rem;
  margin-right: 1rem;
  /* Add margin between charts */
}

.chart-wrapper:last-child {
  margin-right: 0;
  /* Remove margin for the last chart */
}

.chart-title {
  padding: 1rem;
  font-size: 1.5rem;
  text-align: center;
}
</style>

<script lang="ts">
import ManagementHeaderBar from "@/components/ManagementHeaderBar.vue";
import * as echarts from "echarts";
import { ref, onMounted, inject, computed } from "vue";
import { useI18n } from "vue-i18n";
import { AxiosInstance } from "axios";
export default {
  name: "ideaStatisticsView",
  components: {
    ManagementHeaderBar,
  },
  setup() {
    const axiosInstance = inject("axiosInstance") as AxiosInstance;
    const chartDom = ref(null);
    const chartDom2 = ref(null);
    const chartDom3 = ref(null);

    let chartInstance = null;
    let chartInstance2 = null;
    let chartInstance3 = null;

    const { t } = useI18n();
    const value = ref("");
    interface DataItem {
      IdeaCount: number;
      YearMonth: string;
      Status1Count: number;
      Status2Count: number;
      Status3Count: number;
      Status4Count: number;
    }

    interface DataItem2 {
      CommentCount: number;
      YearMonth: string;
    }

    interface DataItem3 {
      UserCount: number;
      YearMonth: string;
    }

    const options = computed(() => [
      {
        value: "999",
        label: t("allTime"),
      },
      {
        value: "12",
        label: t("withinayear"),
      },
      {
        value: "6",
        label: t("withinsixmonths"),
      },
    ]);
    const StartTime = ref();
    const EndTime = ref();
    onMounted(() => {
      let now = new Date();
      now.setDate(now.getDate() + 1);
      EndTime.value = now.toDateString();
      let tempTime = new Date(now.getTime());
      tempTime.setMonth(now.getMonth() - 999);
      StartTime.value = tempTime.toDateString();

      getChartData();
      getCommentChartData();
      getUserChartData();
    });

    const getCommentChartData = async () => {
      return axiosInstance
        .request({
          url: "/api/comment/ChartByMonth",
          method: "get",
          params: {
            StartTime: StartTime.value,
            EndTime: EndTime.value,
          },
        }).then((res) => {
          let data: DataItem2[] = res.data.Data; // 使用 res.data.Data
          data.sort((a, b) => {
            return a.YearMonth.localeCompare(b.YearMonth);
          });
          let xAxisData: string[] = data.map(
            (item: DataItem2) => item.YearMonth
          );
          let seriesData1: number[] = data.map(
            (item: DataItem2) => item.CommentCount
          );
          chartInstance2 = echarts.init(chartDom2.value);
          chartInstance2.setOption({
            tooltip: {
              trigger: "axis",
            },
            color: "#f36633",
            xAxis: {
              data: xAxisData,
            },
            yAxis: {
              type: 'value',
            },
            legend: {
              data: [t("comment")],
            },
            axisPointer: {
              type: "shadow",
            },
            series: [
              {
                name: t("comment"),
                type: "bar",
                data: seriesData1,
                itemStyle: {
                  color: "#f36633",
                },
                label: {
                  show: true,
                  position: "top",
                  formatter: "{c}",
                  textStyle: { color: "#000" },
                },
              },
            ],
          });

        })
    }

    const getUserChartData = async () => {
      return axiosInstance
        .request({
          url: "/api/user/ChartByMonth",
          method: "get",
          params: {
            StartTime: StartTime.value,
            EndTime: EndTime.value,
          },
        }).then((res) => {
          let data: DataItem3[] = res.data.Data; // 使用 res.data.Data
          data.sort((a, b) => {
            return a.YearMonth.localeCompare(b.YearMonth);
          });
          let xAxisData: string[] = data.map(
            (item: DataItem3) => item.YearMonth
          );
          let seriesData1: number[] = data.map(
            (item: DataItem3) => item.UserCount
          );
          chartInstance3 = echarts.init(chartDom3.value);
          chartInstance3.setOption({
            tooltip: {
              trigger: "axis",
            },
            color: "#f36633",
            xAxis: {
              data: xAxisData,
            },
            yAxis: {
              type: 'value',
            },
            legend: {
              data: [t("user")],
            },
            axisPointer: {
              type: "shadow",
            },
            series: [
              {
                name: t("user"),
                type: "bar",
                data: seriesData1,
                itemStyle: {
                  color: "#f36633",
                },
                label: {
                  show: true,
                  position: "top",
                  formatter: "{c}",
                  textStyle: { color: "#000" },
                },
              },
            ],
          });
        })
    }

    const getChartData = async () => {
      return axiosInstance
        .request({
          url: "/api/idea/ChartByMonth",
          method: "get",
          params: {
            StartTime: StartTime.value,
            EndTime: EndTime.value,
          },
        })
        .then((res) => {
          let data: DataItem[] = res.data.Data; // 使用 res.data.Data
          data.sort((a, b) => {
            return a.YearMonth.localeCompare(b.YearMonth);
          });
          let xAxisData: string[] = data.map(
            (item: DataItem) => item.YearMonth
          );
          let seriesData1: number[] = data.map(
            (item: DataItem) => item.Status1Count
          );
          let seriesData2: number[] = data.map(
            (item: DataItem) => item.Status2Count
          );
          let seriesData3: number[] = data.map(
            (item: DataItem) => item.Status3Count
          );
          let seriesData4: number[] = data.map(
            (item: DataItem) => item.Status4Count
          );
          const totalData = seriesData1.map((value, index) => {
            return (
              value +
              seriesData2[index] +
              seriesData3[index] +
              seriesData4[index]
            );
          });
          chartInstance = echarts.init(chartDom.value);
          chartInstance.setOption({
            tooltip: {
              trigger: "axis",
            },
            color: "#f36633",
            xAxis: {
              data: xAxisData,
            },
            yAxis: {},
            legend: {
              data: [t("new"), t("discussion"), t("building"), t("pilot")],
            },
            axisPointer: {
              type: "shadow",
            },
            series: [
              {
                name: t("sum"),
                type: "bar",
                barGap: "-100%",
                statck: "",
                z: 0,
                label: {
                  normal: {
                    show: true,
                    position: "top",
                    formatter: "{c}",
                    textStyle: { color: "#000" },
                  },
                },
                itemStyle: {
                  color: "#00000000",
                },
                data: totalData,
              },
              {
                name: t("new"),
                type: "bar",
                stack: "total",
                data: seriesData1,
                itemStyle: {
                  color: "#f36633",
                },
              },
              {
                name: t("discussion"),
                type: "bar",
                stack: "total",
                data: seriesData2,
                itemStyle: {
                  color: "#00c27c",
                },
              },
              {
                name: t("building"),
                type: "bar",
                stack: "total",
                data: seriesData3,
                itemStyle: {
                  color: "#007cc2",
                },
              },
              {
                name: t("pilot"),
                type: "bar",
                stack: "total",
                data: seriesData4,
                itemStyle: {
                  color: "#8535eb",
                },
              },
            ],
          });
        });
    };
    const selectChange = (e: any) => {
      let now = new Date();
      EndTime.value = now.toDateString();
      let tempTime = new Date(now.getTime());
      tempTime.setMonth(now.getMonth() - e);
      StartTime.value = tempTime.toDateString();
      getChartData();
      getCommentChartData();
      getUserChartData();
    };
    return {
      value,
      options,
      chartDom,
      chartDom2,
      chartDom3,
      selectChange,
    };
  },
};
</script>
